import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 0 C15.523 0 20 4.477 20 10 C20 15.523 15.523 20 10 20 C4.477 20 0 15.523 0 10 C0 4.477 4.477 0 10 0 Z",
		fill: "currentColor"
	})
});
export default SvgCircleSolid;
